// extracted by mini-css-extract-plugin
export default {"handled":"handled___HQ4Pp","leftRight":"leftRight___gau8e","Slider":"Slider___XMoNy","rightContent":"rightContent___nXyQ6"};